import React from 'react';
import { Typography } from '@mui/material';

import Page from './Page';
import Header from './Header';
import StripeCheckout from './StripeCheckout';
import SquareCheckout from './SquareCheckout';
import PaypalCheckout from './PaypalCheckout';

export const STRIPE = 'stripe';
export const SQUARE = 'square';
export const PAYPAL = 'paypal';

const CheckoutForm = props => {
  const {
    provider,
    providerProps
  } = props;

  switch (provider) {
    case PAYPAL:
      return <PaypalCheckout {...providerProps} />;
    case STRIPE:
      return <StripeCheckout {...providerProps} />;
    case SQUARE:
      return <SquareCheckout {...providerProps} />;
    default:
      return null;
  }
}

const Checkout = props => {
  const {
    provider = STRIPE,
    providerProps = {}
  } = props;

  return (
    <Page>
      <Header text="Checkout" />
      <CheckoutForm {...{ provider, providerProps }} />
    </Page>
  );
}

export default Checkout;
